import { Injectable } from '@angular/core';
import { GameExampleDecorator } from '@games/core/example';
import { ListField, StringField } from '@games/core/example/fields';
import { map } from 'rxjs';
import { AbstractTextExample, AbstractTextExampleFactory } from '../shared/example';
import { Text } from '../words';
import { BlindReadingParameters } from './parameters';

type Result = {
  text: Text;
  correctness: number;
};

type UserAnswer = string[];

@GameExampleDecorator
export class BlindReadingExample extends AbstractTextExample<Result, UserAnswer> {
  readonly userAnswerType = new ListField(() => new StringField());

  constructor(
    readonly text: Text,
    readonly filterType: string,
  ) {
    super(text, filterType);
  }

  // protected override _getResult(userAnswer: UserAnswer): Result {
  //   return {

  //   };
  // }
}

@Injectable()
export class BlindReadingExampleFactory extends AbstractTextExampleFactory<
  BlindReadingParameters,
  BlindReadingExample
> {
  constructor() {
    super();
  }

  instantiate() {
    const filterType = this._methodicMaterials.parameters.filterType;
    return this._methodicMaterials.getText().pipe(
      map((res) => {
        return new BlindReadingExample(res, filterType);
      }),
    );
  }
}
